import { Workspace } from '@/types';
import api from './client';

// Workspaces API
export const workspacesAPI = {
  list: async (): Promise<Workspace[]> => {
    const response = await api.get('/workspaces');
    return response.data;
  },
  getById: async (id: string): Promise<Workspace> => {
    const response = await api.get(`/workspaces/${id}`);
    return response.data;
  },
};
